import React, { useState, useRef, useEffect, useMemo, useCallback } from "react";
import {
    Box,
    Card,
    CardContent,
    Typography,
    Divider,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableContainer,
    Paper,
    CardActions,
    Button,
    FormControlLabel,
    Checkbox,
    Tooltip,
    TextField,
    Chip,
} from "@mui/material";
import Scrollbar from "./Scrollbar";
import './style.css';
import TripOriginSharpIcon from '@mui/icons-material/PanoramaFishEye';
import CustomTextField from "../../commons/CustomTextField";
import ReferenceRange from "./ReferenceRange";
import { useLocation, useParams } from "react-router-dom";

import { store } from '../../redux/store/index';
import * as patientActions from "../../redux/actions/patientActions";
import patientActionStatus from "../../redux/commons/patientActionStatus";
import { useSelector } from "react-redux";
import { CircularProgress } from '@mui/material';
import { formatWeeks } from "../../utils/formatWeekAndDays";
import CustomSelectBox from "../../commons/CustomSelect";
import Select from "react-select";
import { API } from "../../api/api";
import IconButton from "@mui/material/IconButton";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { Dialog, DialogContent, } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PreviewIcon from '@mui/icons-material/Preview';
import { socket } from "../../socket/socket";
import AsyncCreatableSelect from "react-select/async-creatable";
import moment from "moment";
import usePermissions from "../../utils/permissions";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import CommonGate from "./Gate";
import Timeline from '@mui/lab/Timeline';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TestApprovalModal from "./TestApprovalModal";
import DeleteTestButton from "./DeleteTestButton";
import { ReactComponent as Male } from '../../assets/male.svg';
import { ReactComponent as Female } from '../../assets/woman.svg';


const styles = {
    card: {
        width: { xs: '100%', sm: 'fit-content' },
        maxWidth: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 3,
        alignSelf: 'stretch',
        boxShadow: 'none',
        border: "1px solid #E6E8EC",
        overflowX: 'auto'
    },
    singleCard: {
        width: { xs: '100%', sm: 'fit-content' },
        maxWidth: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 3,
        alignSelf: 'stretch',
        boxShadow: 'none',
        border: "1px solid #E6E8EC",
        overflowX: 'auto'
    },
    fixedBox: {
        position: 'fixed',
        top: 50,
        right: 60,
        height: '670px',
        width: 5,
        bgcolor: '#FFCA67',
        transition: 'background-color 0.3s ease',
    },
    icon: {
        color: '#FFCA67',
        top: { xl: 415, lg: 144, md: 75 },
        left: { xl: '91.3%', lg: '91.7%', md: '88.7%' },
        width: '1%',
        position: 'absolute',
        fontSize: 'small',
        display: { md: 'none', xl: 'flex' }
    },
    horizontalLine: {
        position: 'fixed',
        top: { xl: 420, lg: 460, md: 470 },
        right: 60,
        width: { xl: '4.5%', lg: '3%', md: '4%' },
        height: 3,
        bgcolor: '#FFCA67',
        transition: 'background-color 0.3s ease',
    },
    tableContainer: {
        borderRadius: 2,
        position: 'relative',
        boxShadow: 'none',
        border: "1px solid #E6E8EC"
    },
    asyncSelect: {
        container: (base) => ({
            ...base,
            // flex: 1,
            width: '159px',
            marginLeft: '15px'
        }),
        control: (base) => ({
            ...base,
            border: "1px solid #E6E8EC",
            padding: '0',
            borderRadius: '5px',
            height: '29px',
        }),
        valueContainer: (base) => ({
            ...base,
            height: '100%',
            padding: '0 8px',
            fontSize: '14px',
        }),
        indicatorSeparator: () => ({
            display: 'none',
        }),
        input: (base) => ({
            ...base,
            margin: 0,
            padding: 0,
            fontSize: '14px',
        }),

        singleValue: (base) => ({
            ...base,
            lineHeight: '29px',
            fontSize: '14px',
        }),
        dropdownIndicator: (base) => ({
            ...base,
        }),
        menu: (base) => ({
            ...base,
            borderRadius: '0',
            marginTop: '0',
            backgroundColor: '#FFF',
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected
                ? "grey"
                : state.isFocused
                    ? "#D3D3D3"
                    : "transparent",
            color: state.isSelected ? "#fff" : "black",
            cursor: "pointer",
        }),
    }
};

const getRepeatTableMaxWidth = (test, isMobile) => {
    if (isMobile) return '100%';
    const numCols = 1 + (test?.repeats?.length || 0);
    const calculated = 130 + numCols * 120;
    return `${Math.max(360, calculated)}px`;
};

const getTableContainerSx = (test, isMobile, options) => ({
    ...styles.tableContainer,
    maxWidth: getRepeatTableMaxWidth(test, isMobile, options),
    width: isMobile ? '100%' : 'fit-content',
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'stretch',
    overflowX: isMobile ? 'auto' : undefined,
    WebkitOverflowScrolling: 'touch',
    pr:'10px'
});


const multiSelectStyle = {
    container: (base) => ({
        ...base,
        width: '100%',
        flex: 1,
    }),
    control: (base) => ({
        ...base,
        width: '100%',
        minWidth: '100%',
        maxWidth: '100%',
        padding: '0 2px',
        borderRadius: 4,
        minHeight: '29px',
        border: "1px solid #919191"
    }),
    valueContainer: (base) => ({
        ...base,
        padding: '0 4px',
        fontSize: '11px',
    }),
    multiValue: (base) => ({
        ...base,
        backgroundColor: '#e0e0e0',
        margin: '1px',
    }),
    multiValueLabel: (base) => ({
        ...base,
        fontSize: '10px',
        padding: '1px 3px',
    }),
    input: (base) => ({
        ...base,
        margin: 0,
        padding: 0,
        fontSize: '10px',
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    indicatorSeparator: () => ({
        display: 'none',
    }),
    dropdownIndicator: (base) => ({
        ...base,
        padding: '2px',
        svg: {
            height: 12,
            width: 12,
        },
    }),
    indicatorsContainer: (base) => ({
        ...base,
        height: '100%',
    }),
};

export const renderFieldControl = ({ val, fieldValue, edit, onValueChange }) => {
    if (val.fieldType === "SINGLE_CHOICE" || val.fieldType === "NESTED") {
        return (
            <CustomSelectBox
                value={fieldValue || ''}
                handleChange={(e) => onValueChange && onValueChange(e)}
                options={val.options || []}
                width="100%"
                edit={edit}
                selectStyle={{
                    borderRadius: '5px',
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: '#FFFF',
                    justifyContent: 'center',
                    fontSize: '12px',
                }}
            />
        );
    }

    if (val.fieldType === "YESNO") {
        return (
            <CustomSelectBox
                value={fieldValue || ''}
                handleChange={(e) => onValueChange && onValueChange(e)}
                options={['Yes', 'No']}
                width="100%"
                edit={edit}
                selectStyle={{
                    borderRadius: '5px',
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: '#FFFF',
                    justifyContent: 'center',
                    fontSize: '12px',
                }}
            />
        );
    }

    if (val.fieldType === "MULTI_CHOICE") {
        const selectOptions = (val.options || []).map(option => ({
            value: option,
            label: option
        }));
        const valArr = Array.isArray(fieldValue)
            ? fieldValue
            : typeof fieldValue === 'string' && fieldValue
                ? fieldValue.split(',')
                : [];

        return (
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <Select
                    isMulti
                    options={selectOptions}
                    value={selectOptions.filter(option => valArr.includes(option.value))}
                    onChange={(selectedOptions) => {
                        const values = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
                        if (onValueChange) onValueChange(values);
                    }}
                    placeholder=""
                    isDisabled={!edit}
                    isSearchable={false}
                    styles={multiSelectStyle}
                    menuPortalTarget={document.body}
                    isClearable={false}
                />
            </Box>
        );
    }

    if (val.fieldType === "CHECKBOX") {
        return (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, justifyContent: 'center' }}>
                {(val.options || []).map((item, idx) => (
                    <FormControlLabel
                        key={idx}
                        control={
                            <Checkbox
                                size="small"
                                color="black"
                                checked={item === fieldValue}
                                disabled={!edit}
                                onClick={() => {
                                    if (edit && onValueChange) {
                                        onValueChange(item === fieldValue ? null : item);
                                    }
                                }}
                            />
                        }
                        label={item}
                    />
                ))}
            </Box>
        );
    }

    return (
        <CustomTextField
            value={fieldValue || ''}
            setValue={(value) => {
                if (onValueChange) onValueChange(value);
            }}
            edit={edit}
            placeholder={val.placeHolder || ''}
            width="100%"
        />
    );
};

const TestBlocks = () => {
    const renderTestName = (item, isBold = false) => {
        if (!item) return null;
        return (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, pr: 7 }}>
                <Box sx={{ textAlign: 'left', wordBreak: 'break-word' }}>
                    {isBold ? (
                        <Typography fontWeight="bold" sx={{ fontSize: '12px' }}>{item.testName}</Typography>
                    ) : (
                        item.testName
                    )}
                </Box>
                {item.memberRole && <Chip
                    size="small"
                    label={item.memberRole === 'HIM' ? "HIM" : "HER"}
                    sx={{
                        bgcolor: item.memberRole === 'HIM' ? "#E3F2FD" : "pink",
                        color:item.memberRole === 'HIM'? "#1565C0":'#7E264F',
                        height: 20,
                        fontSize: 12,
                        fontWeight: 600,
                    }}
                />}
            </Box>
        );
    };
    const patientReducer = useSelector(state => state.patientReducer)
    const selectedWeekRef = useRef(null);
    const currentTestsRef = useRef(null);
    const [showPastWeeks, setPastWeeks] = useState(false);
    const [edit, setEditable] = useState(true)
    const [tests, setTests] = useState([]);  // For the current tests
    const { patientId, consultationId } = useParams();
    const [pastTests, setPastTests] = useState([]); // For the past tests

    const location = useLocation();
    const [loader, setLoader] = useState(true)
    const [fileMap, setFileMap] = useState({});
    const [signedUrlMap, setSignedUrlMap] = useState({});
    const [uploadingMap, setUploadingMap] = useState({});

    const [openModal, setOpenModal] = useState(false);
    const [previewUrl, setPreviewUrl] = useState("");
    const [previewType, setPreviewType] = useState("");

    const fileInputRefs = useRef({});
    const [selectedAdditionalTest, setSelectedAdditionalTest] = useState(null);
    const [customTest, setCustomTestFormat] = useState([])
    const inputRef = useRef(null);
    const { hasPermission } = usePermissions();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const patientType = patientReducer?.patientInfo?.patientType || 'OBSTETRIC'

    const [approvalModalOpen, setApprovalModalOpen] = useState(false);
    
    const testsNeedingApproval = useMemo(() => {
        const allTests = patientReducer?.tests?.flatMap(group => group.tests) || [];
        return allTests.filter(t => t.fileMediaId && t.approvedByDoctor === false); //
    }, [patientReducer?.tests]);

    const refreshTests = () => store.dispatch(patientActions.getPatientTestsRequestAction(patientId));

    const handleClick = (testId) => {
        fileInputRefs.current[testId]?.click();
    };

    // generate signed URL
    const generateUploadSignedUrl = async (payload) => {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const res = await API.post(`${baseUrl}/v1/media/generate-signed-url-to-upload`, payload)
        return res;
    };

    // save test report
    const saveAntenatalTestReport = async (
        patientId,
        testId,
        fileMediaId
    ) => {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const res = await API.post(
            `${baseUrl}/v1/tests/patients/${patientId}/antenatal-tests/${testId}`,
            {
                fileMediaId
            }
        );

        return res;
    };

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const mode = queryParams.get('mode');
        if (mode) {
            setEditable(mode == "view" ? false : hasPermission("TEST_CREATE") ? true : false);
        }
    }, [location.search]);

    useEffect(() => {
        if (patientId) {
            store.dispatch(patientActions.getPatientTestsRequestAction(patientId));
        }
    }, [patientId]);

    useEffect(() => {
        if (!patientId) return;
        const handleCommandOutput = (data) => {
            console.log("data came on event", data)
            const [, , rawCardType] = data?.data?.originActionType?.split('.');

            let cardType = rawCardType;
            let cardKey = rawCardType;
            if (rawCardType.includes(':')) {
                const [cardCategory, id] = rawCardType.split(':');
                cardType = cardCategory
                cardKey = rawCardType
            }
            if (consultationId !== data?.data?.consultationId) {
                return
            }
            if (
                data?.actionType === "commandOutput.refreshWebDashboard"
            ) {
                if (cardType == "antenatalTest" || cardType == "condition"||cardType == "conditions") {
                    store.dispatch(patientActions.getPatientTestsRequestAction(patientId));
                }
            }
        };
        socket.on("commandOutput", handleCommandOutput);
    }, [patientId]);

    useEffect(() => {
        if (patientReducer?.testCreated?.id) {
            store.dispatch(patientActions.resetTestCreationState())
            if (patientId) {
                store.dispatch(patientActions.getPatientDetailsRequestAction(patientId, true));
            }
        }
    }, [patientReducer?.testCreated]);

    const isValuePresent = (test) => {
        // If test has children, validate children
        if (test.value == null && Array.isArray(test.children) && test.children.length > 0) {
            return test?.children?.every(isValuePresent);
        }

        // test → must have a value
        return test.value !== null && test.value !== undefined;
    };

    useEffect(() => {
        if (patientReducer.tests) {
            const currentTests = patientReducer.tests?.[0]?.tests || [];
            const pastTests = patientReducer.tests.slice(1) || [];

            // if (JSON.stringify(currentTests) !== JSON.stringify(tests)) {
            const updatedTests = currentTests.map(test => {
                const submitted = Boolean(
                    test.isSubmitted ||
                    test.reportedAt ||
                    (Array.isArray(test?.values) && test.values.length > 0 && test.values.every(isValuePresent))
                );
                return { ...test, submitted };
            });
            setTests(updatedTests);
            // }

            const updatedPastTests = pastTests.map(test => {
                const updatedTests = test.tests.map(testItem => {
                    const submitted = Boolean(
                        testItem.isSubmitted ||
                        testItem.reportedAt ||
                        (Array.isArray(testItem?.values) && testItem.values.length > 0 && testItem.values.every(isValuePresent))
                    );
                    return { ...testItem, submitted };
                });
                return { ...test, tests: updatedTests };
            });
            setPastTests(updatedPastTests);
        }
    }, [patientReducer?.tests]);

    const handleCurrentTestsClick = () => {
        setPastWeeks(false)
        if (currentTestsRef.current) {
            currentTestsRef.current.scrollIntoView({
                behavior: "smooth",
                block: 'end'
            });
        }
    };

    const setValue = (id, fieldKey, newValue) => {
        const updatedTests = tests.map(test => {
            if (test.id === id) {
                test.submitted = test.submitted == true && false
                const updatedValues = test.values.map(value => {
                    if (value.fieldKey === fieldKey) {
                        return { ...value, value: newValue };
                    }
                    return value;
                });
                return { ...test, values: updatedValues };
            }
            return test;
        });
        setTests(updatedTests);
    };

    const setLabName = (id, newLabName) => {
        setTests(prev => prev.map(test => {
            if (test.id === id) {
                return { ...test, labName: newLabName, submitted: false };
            }
            return test;
        }));
    };

    const setRepeatWeekLabName = (id, newLabName, repeatIndex) => {
        setTests(prev => prev.map(test => {
            if (test.id === id) {
                const updatedRepeats = (test.repeats || []).map((repeatWeek, idx) => {
                    if (idx === repeatIndex) {
                        return { ...repeatWeek, labName: newLabName };
                    }
                    return repeatWeek;
                });
                return { ...test, repeats: updatedRepeats, submitted: false };
            }
            return test;
        }));
    };

    const setPastLabName = (id, newLabName, pastTestIndex) => {
        setPastTests(prev => prev.map((pastGroup, gIdx) => {
            if (gIdx === pastTestIndex) {
                const updatedTests = pastGroup.tests.map(testItem => {
                    if (testItem.id === id) {
                        return { ...testItem, labName: newLabName, submitted: false };
                    }
                    return testItem;
                });
                return { ...pastGroup, tests: updatedTests };
            }
            return pastGroup;
        }));
    };

    const setPastRepeatWeekLabName = (id, newLabName, pastTestIndex, repeatIndex) => {
        setPastTests(prev => prev.map((pastGroup, gIdx) => {
            if (gIdx === pastTestIndex) {
                const updatedTests = pastGroup.tests.map(testItem => {
                    if (testItem.id === id) {
                        const updatedRepeats = (testItem.repeats || []).map((repeatWeek, rIdx) => {
                            if (rIdx === repeatIndex) {
                                return { ...repeatWeek, labName: newLabName };
                            }
                            return repeatWeek;
                        });
                        return { ...testItem, repeats: updatedRepeats, submitted: false };
                    }
                    return testItem;
                });
                return { ...pastGroup, tests: updatedTests };
            }
            return pastGroup;
        }));
    };

    const setCustomTestValue = (id, fieldKey, newValue) => {
        const updatedTests = customTest.map(test => {
            if (test.id === id) {
                test.submitted = test.submitted == true && false
                const updatedValues = test.values.map(value => {
                    if (value.fieldKey === fieldKey) {
                        return { ...value, value: newValue };
                    }
                    return value;
                });
                return { ...test, values: updatedValues };
            }
            return test;
        });
        setCustomTestFormat(updatedTests);
    };

    const setPastTestValue = (id, fieldKey, newValue, week) => {

        const updatedTests = pastTests.map(test => {
            if (test.week === week) {
                const updatedInnerTests = test.tests.map(innerTest => {
                    if (innerTest.id === id) {
                        return {
                            ...innerTest,
                            submitted: innerTest.submitted == true && false,
                            values: innerTest.values.map(value => {
                                if (value.fieldKey === fieldKey) {
                                    return { ...value, value: newValue };
                                }
                                return value;
                            })
                        };
                    }
                    return innerTest;
                });

                return { ...test, tests: updatedInnerTests };
            }
            return test;
        });

        setPastTests(updatedTests);
    };    const setChildrenValues = (val, testId, parentFieldKey, childFieldKey) => {
        setTests((prevState) => {
            const updated = [...prevState];
            const entryIndex = updated.findIndex(entry => entry.id === testId);

            if (entryIndex !== -1) {
                updated[entryIndex].submitted = updated[entryIndex].submitted === true && false;
                
                let parentFound = false;
                let updatedValues = (updated[entryIndex].values || []).map(value => {
                    if (value.fieldKey === parentFieldKey) {
                        parentFound = true;
                        let childFound = false;
                        let updatedChildren = (value.children || []).map(child => {
                            if (child.fieldKey === childFieldKey) {
                                childFound = true;
                                return { ...child, value: val };
                            }
                            return child;
                        });
                        if (!childFound) {
                            updatedChildren = [...updatedChildren, { fieldKey: childFieldKey, value: val }];
                        }
                        return {
                            ...value,
                            children: updatedChildren
                        };
                    }
                    return value;
                });
                
                if (!parentFound) {
                    updatedValues = [...updatedValues, {
                        fieldKey: parentFieldKey,
                        children: [{ fieldKey: childFieldKey, value: val }]
                    }];
                }
                
                updated[entryIndex].values = updatedValues;
            }
            return updated;
        });
    };

    const setPastChildrenValues = (val, testId, parentFieldKey, childFieldKey, pastTestIndex) => {
        setPastTests((prevState) => {
            return prevState.map((testGroup, index) => {
                if (index !== pastTestIndex) return testGroup;

                const updatedTests = testGroup.tests.map((test) => {
                    if (test.id !== testId) return test;

                    let parentFound = false;
                    let updatedValues = (test.values || []).map(v => {
                        if (v.fieldKey !== parentFieldKey) return v;
                        
                        parentFound = true;
                        let childFound = false;
                        let updatedChildren = (v.children || []).map(child => {
                            if (child.fieldKey !== childFieldKey) return child;
                            childFound = true;
                            return { ...child, value: val };
                        });
                        
                        if (!childFound) {
                            updatedChildren = [...updatedChildren, { fieldKey: childFieldKey, value: val }];
                        }

                        return { ...v, children: updatedChildren };
                    });

                    if (!parentFound) {
                        updatedValues = [...updatedValues, {
                            fieldKey: parentFieldKey,
                            children: [{ fieldKey: childFieldKey, value: val }]
                        }];
                    }

                    return { ...test, values: updatedValues, submitted: test.submitted === true && false };
                });

                return { ...testGroup, tests: updatedTests };
            });
        });
    };

    const setPastChildrenNestedValues = (
        val,
        testId,
        valueIndex,
        childIndex,
        innerNestedIndex,
        pastTestIndex
    ) => {
        setPastTests((prevState) => {
            return prevState.map((testGroup, index) => {
                if (index !== pastTestIndex) return testGroup;

                const updatedTests = testGroup.tests.map((test) => {
                    if (test.id !== testId) return test;

                    const updatedValues = test.values.map((v, vIndex) => {
                        if (vIndex !== valueIndex) return v;

                        const updatedChildren = v.children.map((child, cIndex) => {
                            if (cIndex !== childIndex) return child;

                            const updatedInnerChildren = child.children.map((innerChild, iIndex) => {
                                if (iIndex !== innerNestedIndex) return innerChild;
                                return { ...innerChild, value: val };
                            });

                            return { ...child, children: updatedInnerChildren };
                        });

                        return { ...v, children: updatedChildren };
                    });

                    return { ...test, submitted: test.submitted == true && false, values: updatedValues };
                });

                return { ...testGroup, tests: updatedTests };
            });
        });
    };


    const setNestedChildrenValues = (val, testId, valueIndex, childIndex, innerNestedIndex) => {
        setTests((prevState) => {
            let updated = [...prevState]
            const entryIndex = updated.findIndex(entry => entry.id === testId)
            updated[entryIndex].submitted = updated[entryIndex].submitted == true && false

            if (entryIndex !== -1) {
                updated[entryIndex].values[valueIndex].children[childIndex].children[innerNestedIndex].value = val
            }
            return updated
        })
    };

    const setNestedChildren = (val, testId, valueIndex, childIndex,) => {
        setTests((prevState) => {
            let updated = [...prevState]
            const entryIndex = updated.findIndex(entry => entry.id === testId)
            updated[entryIndex].submitted = updated[entryIndex].submitted == true && false

            if (entryIndex !== -1) {
                updated[entryIndex].values[valueIndex].children[childIndex].value = val
            }
            return updated
        })
    };

    const setNestedChildValueByKey = (testId, childKey, newValue) => {
        setTests((prevTests) =>
            prevTests.map((t) => {
                if (t.id !== testId) return t;
                let found = false;
                const updateValTree = (values) => {
                    return (values || []).map((v) => {
                        if (v.fieldKey === childKey) {
                            found = true;
                            return { ...v, value: newValue };
                        }
                        if (v.children && v.children.length > 0) {
                            return { ...v, children: updateValTree(v.children) };
                        }
                        return v;
                    });
                };
                let updatedValues = updateValTree(t.values || []);
                if (!found) {
                    updatedValues = [...updatedValues, { fieldKey: childKey, value: newValue }];
                }
                return { ...t, submitted: false, values: updatedValues };
            })
        );
    };

    const setPastNestedChildValueByKey = (testId, childKey, newValue, pastTestIndex) => {
        setPastTests((prevState) =>
            prevState.map((testGroup, pIdx) => {
                if (pIdx !== pastTestIndex) return testGroup;
                const updatedTests = testGroup.tests.map((t) => {
                    if (t.id !== testId) return t;
                    let found = false;
                    const updateValTree = (values) => {
                        return (values || []).map((v) => {
                            if (v.fieldKey === childKey) {
                                found = true;
                                return { ...v, value: newValue };
                            }
                            if (v.children && v.children.length > 0) {
                                return { ...v, children: updateValTree(v.children) };
                            }
                            return v;
                        });
                    };
                    let updatedValues = updateValTree(t.values || []);
                    if (!found) {
                        updatedValues = [...updatedValues, { fieldKey: childKey, value: newValue }];
                    }
                    return { ...t, submitted: false, values: updatedValues };
                });
                return { ...testGroup, tests: updatedTests };
            })
        );
    };

    useEffect(() => {
        if (patientReducer?.tests) {
            setLoader(false);
        }
    }, [patientReducer?.tests, consultationId]);

    function findFieldValue(data, targetFieldKey) {
        for (const item of data) {
            if (item.fieldKey === targetFieldKey) {
                return item.value;
            }

            if (item.children && item.children.length > 0) {
                const result = findFieldValue(item.children, targetFieldKey);
                if (result !== undefined) {
                    return result;
                }
            }
        }

        return undefined;
    }

    const rowStyle = {
        px: { xs: 1, md: 2 },
        py: 0.4,
        border: 'none',
        lineHeight: 1,
        fontSize: { xs: '10px', md: '11px' },
    }

    const pollExtractionJob = useCallback(async (jobId, testId, mediaId) => {
        let baseUrl = process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEVELOP : process.env.REACT_APP_PROD;
        const token = localStorage.getItem("token");
        
        try {
            const response = await fetch(`${baseUrl}/v1/tests/patients/${patientId}/antenatal-tests/extraction-jobs/${jobId}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const result = await response.json();
            
            if (result?.data?.status === 'COMPLETED' || result?.data?.status === 'FAILED') {
                store.dispatch(patientActions.getPatientTestsRequestAction(patientId));
                setUploadingMap(prev => ({ ...prev, [testId]: false }));
                setFileMap(prev => ({ ...prev, [testId]: null }));
                setSignedUrlMap(prev => ({ ...prev, [testId]: null }));
            } else {
                setTimeout(() => pollExtractionJob(jobId, testId, mediaId), 3000);
            }
        } catch (err) {
            console.error("Polling error:", err);
            setUploadingMap(prev => ({ ...prev, [testId]: false }));
        }
    }, [patientId]);

    const fileUpload = useCallback(async (testId, file) => {
        if (!file) return;

        setUploadingMap(prev => ({ ...prev, [testId]: true }));
        const ext = "." + file.name.split(".").pop();

        const response = await generateUploadSignedUrl({
            entityType: "TEST_REPORT",
            mediaType: file.type,
            mediaSize: file.size,
            fileExtension: ext,
        });

        const signedUrlData = response.data;
        setSignedUrlMap(prev => ({
            ...prev,
            [testId]: signedUrlData
        }));

        const xhr = new XMLHttpRequest();

        xhr.open("PUT", signedUrlData.uploadUrl);
        xhr.setRequestHeader(
            "Content-Type",
            file.type || "application/octet-stream"
        );

        xhr.onload = async () => {
            if (xhr.status === 200 || xhr.status === 204) {
                setSignedUrlMap(prev => ({
                    ...prev,
                    [testId]: signedUrlData
                }));

                try {
                    let baseUrl = process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEVELOP : process.env.REACT_APP_PROD;
                    const token = localStorage.getItem("token");
                    
                    const jobResponse = await fetch(`${baseUrl}/v1/tests/patients/${patientId}/antenatal-tests/extraction-jobs`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${token}`
                        },
                        body: JSON.stringify({
                            mediaId: signedUrlData.media.id,
                            testId: testId
                        })
                    });
                    
                    const jobResult = await jobResponse.json();
                    
                    if (jobResult.success && jobResult.data?.jobId) {
                        // Start polling
                        pollExtractionJob(jobResult.data.jobId, testId, signedUrlData.media.id);
                    } else {
                        // Fallback
                        await handleSaveTest(testId, signedUrlData.media.id);
                        setUploadingMap(prev => ({ ...prev, [testId]: false }));
                    }
                } catch(err) {
                    console.error("Extraction start error:", err);
                    await handleSaveTest(testId, signedUrlData.media.id);
                    setUploadingMap(prev => ({ ...prev, [testId]: false }));
                }
            } else {
                console.error("Upload failed:", xhr.status);
                setUploadingMap(prev => ({ ...prev, [testId]: false }));
            }
        };

        xhr.onerror = (e) => {
            setUploadingMap(prev => ({ ...prev, [testId]: false }));
            console.error("XHR error:", e);
        };

        xhr.send(file);



    }, [fileMap, patientId, pollExtractionJob]);

    const handleFileChange = useCallback((e, testId) => {
        const selectedFile = e.target.files?.[0];
        if (!selectedFile) return;

        if (selectedFile && selectedFile.type !== "application/pdf") {
            window.alert("Only PDF files are allowed");
            e.target.value = "";
            return;
        }

        setFileMap(prev => ({
            ...prev,
            [testId]: selectedFile
        }));
        fileUpload(testId, selectedFile);
    }, [fileUpload]);


    const handleSaveTest = useCallback(async (testId, mediaId) => {
        if (!mediaId) {
            alert("Please upload file first");
            return;
        }

        try {
            const response = await saveAntenatalTestReport(
                patientId,
                testId,
                mediaId
            );

            if (!response.success) throw new Error(response.message);

            setTests(prevTests =>
                prevTests.map(test =>
                    test.id == testId ? { ...test, fileMediaId: mediaId } : test
                )
            );

            setPastTests(prevPastTests =>
                prevPastTests.map(testGroup => ({
                    ...testGroup,
                    tests: testGroup.tests.map(test =>
                        test.id == testId ? { ...test, fileMediaId: mediaId } : test
                    )
                }))
            );

            // cleanup
            setFileMap(prev => ({ ...prev, [testId]: null }));
            setSignedUrlMap(prev => ({ ...prev, [testId]: null }));

        } catch (err) {
            console.error("Save error:", err);
        }

    }, [patientId, setTests, setPastTests]);

    const handleView = async (mediaId) => {
        try {
            let baseUrl =
                process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEVELOP
                    : process.env.REACT_APP_PROD;

            const token = localStorage.getItem("token");

            const res = await fetch(`${baseUrl}/v1/media/${mediaId}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            const fileUrl = res?.url;

            if (fileUrl) {
                setPreviewUrl(fileUrl);

                // detect type
                if (fileUrl.includes(".pdf")) {
                    setPreviewType("pdf");
                } else {
                    setPreviewType("image");
                }

                setOpenModal(true);
            }
        } catch (err) {
            console.error("View error:", err);
        }
    };

    const loadAdditionalTestOptions = async (inputValue) => {
        try {
            if (!inputValue || inputValue.length < 2) {
                return [];
            }

            const response = await API.get(
                `/v1/tests?pageNo=1&pageSize=20&search=${inputValue}`
            );

            if (!response.success) {
                return [];
            }

            return response.data?.map((item) => ({
                ...item,
                label: item.testName,
                value: item.id,
            })) || [];
        } catch (error) {
            console.error("Error loading tests:", error);
            return [];
        }
    };



    const testsScrollContent = (
        <Box sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: { xs: 1, md: 0.5 },
            // alignItems: "flex-start",
            flexDirection: { xs: 'column', sm: 'row' },
            width: '100%',
            minWidth: 0,
        }}>
            {
                customTest?.length > 0 && customTest.map((cTest) => {
                    return <Card
                        key={cTest.id}
                        sx={{
                            ...styles.card,
                            position: 'relative'
                        }}
                    >
                        <Box
                            sx={{
                                position: "absolute",
                                top: 10,
                                right: 10,
                                zIndex: 10,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            {cTest?.fileMediaId ? (
                                <Tooltip title="Click here to view the report">
                                    <IconButton
                                        onClick={() => handleView(cTest?.fileMediaId)}
                                        size="small"
                                        sx={{
                                            p: 0,
                                            width: 20,
                                            height: 20,
                                        }}
                                    >
                                        <PreviewIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            ) : uploadingMap[cTest.id] ? (
                                <CircularProgress size={18} />
                            ) : (
                                <Tooltip title="Click here to upload the report">
                                    <IconButton
                                        onClick={() => handleClick(cTest.id)}
                                        size="small"
                                        sx={{
                                            p: 0,
                                            width: 20,
                                            height: 20,
                                        }}
                                    >
                                        <UploadFileIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            )}
                        </Box>

                        <CardContent sx={{
                            display: "flex",
                            flexDirection: "column",
                            flex: 1,
                        }}>
                            <input
                                type="file"
                                ref={(el) => (fileInputRefs.current[cTest.id] = el)}
                                hidden
                                onChange={async (e) => {
                                    const payload = {
                                        tenantTestId: cTest.id,
                                        patientId,
                                        consultationId,
                                        customValue: null,
                                        date: moment(cTest.customValue).format('YYYY-MM-DD'),
                                        values: cTest.values,
                                    }
                                    const response = await API.post(
                                        "/v1/tests",
                                        payload
                                    );

                                    if (!response.success) {
                                        return;
                                    }
                                    setCustomTestFormat((prevState) => {
                                        return prevState.filter(entry => entry.id !== cTest.id)
                                    })
                                    handleFileChange(e, response?.data?.id)
                                    store.dispatch(patientActions.getPatientTestsRequestAction(patientId));
                                }}
                            />
                            <Box display="flex" justifyContent="space-between" mb={1}>
                                {renderTestName(cTest, true)}
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }} mt={1}>
                                <Box sx={{ width: '150px', minWidth: '150px', maxWidth: '150px', pr: 1, flexShrink: 0 }}>
                                    <Typography textAlign='left' fontWeight="300" lineHeight={1.2} sx={{ fontSize: '11px' }}>
                                        Date
                                    </Typography>
                                </Box>
                                <Box sx={{ width: '150px', minWidth: '150px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <TextField
                                        type="date"
                                        fullWidth
                                        inputRef={inputRef}
                                        value={moment(cTest.customValue).format('YYYY-MM-DD') || ''}
                                        onChange={(e) => {
                                            const updatedTests = customTest.map(test => {
                                                if (test.id === cTest.id) {
                                                    return { ...test, customValue: moment(e.target.value).toISOString() };
                                                }
                                                return test;
                                            });
                                            setCustomTestFormat(updatedTests);
                                        }}
                                        sx={{
                                            '& input': {
                                                height: '24px !important',
                                                backgroundColor: '#FFF',
                                                borderRadius: '5px',
                                                padding: '0 4px !important',
                                                fontSize: '11px',
                                                textAlign: 'center',
                                            },
                                            '& .MuiOutlinedInput-root': {
                                                '& fieldset': {
                                                    border: "1px solid #919191",
                                                },
                                                '&:hover fieldset': {
                                                    border: '1px solid #919191',
                                                },
                                                '&.Mui-focused fieldset': {
                                                    border: '1px solid #919191',
                                                },
                                            },
                                        }}
                                    />
                                </Box>
                                <Box sx={{ minWidth: '35px', pl: 0.5, flexShrink: 0 }} />
                            </Box>
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 1 }}>
                                {cTest?.fields?.length > 0 && cTest.fields.map((val, index) => {
                                    const fieldValue = cTest?.values?.find(v => v.fieldKey === val.fieldKey)?.value || '';
                                    return (
                                        <Box
                                            key={index}
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                width: '100%',
                                            }}
                                        >
                                            <Box sx={{ width: '150px', minWidth: '150px', maxWidth: '150px', pr: 1, flexShrink: 0 }}>
                                                <ReferenceRange printed={cTest?.referenceRange?.[val.fieldKey]} template={val.referenceRange}>
                                                    <Typography textAlign='left' fontWeight="300" lineHeight={1.2} sx={{ fontSize: '11px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                        {val.fieldName}
                                                    </Typography>
                                                </ReferenceRange>
                                            </Box>
                                            <Box sx={{ width: '150px', minWidth: '150px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                {renderFieldControl({
                                                    val,
                                                    fieldValue,
                                                    edit,
                                                    onValueChange: (e) => setCustomTestValue(cTest.id, val.fieldKey, e)
                                                })}
                                            </Box>
                                            <Box sx={{ minWidth: '35px', pl: 0.5, display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexShrink: 0 }}>
                                                {val.unit ? (
                                                    <Typography sx={{ fontSize: '11px', fontWeight: '300', whiteSpace: 'nowrap' }}>
                                                        {val.unit}
                                                    </Typography>
                                                ) : null}
                                            </Box>
                                        </Box>
                                    );
                                })}
                            </Box>
                        </CardContent>

                        {edit && <Box
                            sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                padding: 1,
                                marginTop: "auto",
                            }}
                        >
                            {cTest.submitted ? <Typography
                                sx={{ height: '19px',px:2, fontSize: '9px', backgroundColor: 'rgba(134, 144, 148, 0.6)', color: '#FFF', borderRadius: '5px', alignContent: 'center' }}>
                                SUBMITTED
                            </Typography> : <Button
                                variant="contained"
                                onClick={async () => {
                                    setCustomTestFormat((prevState) => {
                                        let updated = [...prevState]
                                        const entryIndex = updated.findIndex(entry => entry.id === cTest.id)
                                        updated[entryIndex].submitted = true
                                        return updated
                                    })

                                    const payload = {
                                        tenantTestId: cTest.id,
                                        patientId,
                                        consultationId,
                                        customValue: null,
                                        date: moment(cTest.customValue).format('YYYY-MM-DD'),
                                        values: cTest.values,
                                    }

                                    const response = await API.post(
                                        "/v1/tests",
                                        payload
                                    );

                                    if (!response.success) {
                                        return;
                                    }

                                    setCustomTestFormat((prevState) => {
                                        return prevState.filter(entry => entry.id !== cTest.id)
                                    })
                                    store.dispatch(patientActions.getPatientTestsRequestAction(patientId));

                                }}
                                sx={{ height: '19px', width: '58px', fontSize: '9px', backgroundColor: '#F27704' }}
                            >
                                Submit
                            </Button>}
                        </Box>}
                    </Card>

                })
            }
            {tests.length !== 0 ? tests.map(test => (
                !test.isRepeated ? (

                    <Card
                        key={test.id}
                        sx={{
                            ...styles.singleCard,
                            position: 'relative',
                        }}
                    >
                        <Box
                            sx={{
                                position: "absolute",
                                top: 10,
                                right: 10,
                                zIndex: 10,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            {test?.fileMediaId ? (
                                <Tooltip title="Click here to view the report">
                                    <IconButton
                                        onClick={() => handleView(test?.fileMediaId)}
                                        size="small"
                                        sx={{
                                            p: 0,
                                            width: 20,
                                            height: 20,
                                        }}
                                    >
                                        <PreviewIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            ) : uploadingMap[test.id] ? (
                                <CircularProgress size={18} />
                            ) : (
                                <Tooltip title="Click here to upload the report">
                                    <IconButton
                                        onClick={() => handleClick(test.id)}
                                        size="small"
                                        sx={{
                                            p: 0,
                                            width: 20,
                                            height: 20,
                                        }}
                                    >
                                        <UploadFileIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            )}
                            {edit && <DeleteTestButton test={test} onDeleted={refreshTests} />}
                        </Box>
                        <CardContent sx={{
                            display: "flex",
                            flexDirection: "column",
                            flex: 1,
                        }}>
                            <input
                                type="file"
                                ref={(el) => (fileInputRefs.current[test.id] = el)}
                                hidden
                                onChange={(e) => handleFileChange(e, test.id)}
                            />
                            <Box display="flex" justifyContent="space-between" mb={1}>
                                {renderTestName(test, true)}
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                <Box sx={{ width: '150px', minWidth: '150px', maxWidth: '150px', pr: 1, flexShrink: 0 }}>
                                    <Typography textAlign='left' fontWeight="300" lineHeight={1.2} sx={{ fontSize: '11px' }}>
                                        Lab Name
                                    </Typography>
                                </Box>
                                <Box sx={{ width: '150px', minWidth: '150px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <CustomTextField
                                        value={test.labName || ''}
                                        setValue={(newLabName) => setLabName(test.id, newLabName)}
                                        edit={edit}
                                        placeholder="Lab Name"
                                        width="100%"
                                    />
                                </Box>
                                <Box sx={{ minWidth: '35px', pl: 0.5, flexShrink: 0 }} />
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }} mt={0.5}>
                                <Box sx={{ width: '150px', minWidth: '150px', maxWidth: '150px', pr: 1, flexShrink: 0 }}>
                                    <Typography textAlign='left' fontWeight="300" lineHeight={1.2} sx={{ fontSize: '11px' }}>
                                        {patientType == "GYNECOLOGY" ? "Date" : "Week"}
                                    </Typography>
                                </Box>
                                <Box sx={{ width: '150px', minWidth: '150px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Typography textAlign='center' sx={{ fontSize: '11px' }}>
                                        {patientType !== "GYNECOLOGY" ? formatWeeks(test.week) : moment(test.updatedAt).format('DD-MM-YYYY')}
                                    </Typography>
                                </Box>
                                <Box sx={{ minWidth: '35px', pl: 0.5, flexShrink: 0 }} />
                            </Box>
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 1 }}>
                                {test?.tenantTest?.fields?.length > 0 && test.tenantTest.fields.map((val, index) => {
                                    const fieldValue = test?.values?.find(v => v.fieldKey === val.fieldKey)?.value || '';
                                    return (
                                        <React.Fragment key={index}>
                                            {val.fieldType === 'OBJECT' && (val?.children || []).map((child, idx) => (
                                                <Box
                                                    key={`${child.fieldKey}-${idx}`}
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        width: '100%',
                                                        mt: 0.5
                                                    }}
                                                >
                                                    <Box sx={{ width: '150px', minWidth: '150px', pr: 0.5, flexShrink: 0 }}>
                                                        <ReferenceRange printed={test?.referenceRange?.[child.fieldKey]} template={child.referenceRange}>
                                                            <Typography textAlign='left' fontWeight="300" lineHeight={1.2} sx={{ fontSize: '11px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                {child.fieldName}
                                                            </Typography>
                                                        </ReferenceRange>
                                                    </Box>
                                                    <Box sx={{ width: { xs: 'auto', sm: '130px' }, flex: { xs: 1, sm: 'none' }, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <CustomTextField
                                                            value={findFieldValue(test.values, child.fieldKey) || ''}
                                                            setValue={(childrenValue) => setChildrenValues(childrenValue, test.id, val.fieldKey, child.fieldKey)}
                                                            edit={edit}
                                                            width="100%"
                                                        />
                                                    </Box>
                                                    <Box sx={{ width: '15%' }} />
                                                </Box>
                                            ))}
                                            {val.fieldType !== 'OBJECT' && (
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        width: '100%',
                                                    }}
                                                >
                                                    <Box sx={{ width: '150px', minWidth: '150px', maxWidth: '150px', pr: 1, flexShrink: 0 }}>
                                                        <ReferenceRange printed={test?.referenceRange?.[val.fieldKey]} template={val.referenceRange}>
                                                            <Typography textAlign='left' fontWeight="300" lineHeight={1.2} sx={{ fontSize: '11px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                {val.fieldName}
                                                            </Typography>
                                                        </ReferenceRange>
                                                    </Box>
                                                    <Box sx={{ width: '150px', minWidth: '150px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        {renderFieldControl({
                                                            val,
                                                            fieldValue,
                                                            edit,
                                                            onValueChange: (value) => setValue(test.id, val.fieldKey, value)
                                                        })}
                                                    </Box>
                                                    <Box sx={{ minWidth: '35px', pl: 0.5, display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexShrink: 0 }}>
                                                        {val.unit ? (
                                                            <Typography sx={{ fontSize: '11px', fontWeight: '300', whiteSpace: 'nowrap' }}>
                                                                {val.unit}
                                                            </Typography>
                                                        ) : null}
                                                    </Box>
                                                </Box>
                                            )}
                                            {val.fieldType !== 'OBJECT' && (val?.children?.length ?? 0) > 0 && (
                                                <Box sx={{ width: '100%', mt: 0.5 }}>
                                                    {(val?.children || []).map((nestedChildren, nestedIndex) => {
                                                        const hasSubChildren = (nestedChildren?.children || []).length > 0;
                                                        return (
                                                            <Box key={nestedIndex} sx={{ width: '100%', mt: 0.5 }}>
                                                                {hasSubChildren ? (
                                                                    <>
                                                                        {nestedChildren.fieldName && (
                                                                            <Typography textAlign='left' fontWeight="400" lineHeight={1} sx={{ fontSize: '11px', mb: 0.5 }}>
                                                                                {nestedChildren.fieldName}
                                                                            </Typography>
                                                                        )}
                                                                        {(nestedChildren?.children || []).map((innerNestedChildren, innerNestedIndex) => (
                                                                            <Box
                                                                                key={`${innerNestedChildren.fieldKey}-${innerNestedIndex}`}
                                                                                sx={{
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    mt: 0.5,
                                                                                    width: '100%'
                                                                                }}
                                                                            >
                                                                                <Box sx={{ width: '150px', minWidth: '150px', maxWidth: '150px', pr: 1, flexShrink: 0 }}>
                                                                                    <Typography textAlign='left' fontWeight="300" lineHeight={1.2} sx={{ fontSize: '11px', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>
                                                                                        {innerNestedChildren.fieldName}
                                                                                    </Typography>
                                                                                </Box>
                                                                                <Box sx={{ width: '150px', minWidth: '150px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                                    {renderFieldControl({
                                                                                        val: innerNestedChildren,
                                                                                        fieldValue: findFieldValue(test.values, innerNestedChildren.fieldKey),
                                                                                        edit: edit && (!val?.options?.includes('Positive') ? true : fieldValue === 'Positive'),
                                                                                        onValueChange: (newVal) => setNestedChildValueByKey(test.id, innerNestedChildren.fieldKey, newVal)
                                                                                    })}
                                                                                </Box>
                                                                                <Box sx={{ width: { xs: '40px', sm: '60px' }, pl: 0.5, display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexShrink: 0 }}>
                                                                                    {innerNestedChildren.unit ? (
                                                                                        <Typography sx={{ fontSize: '11px', fontWeight: '300', whiteSpace: 'nowrap' }}>
                                                                                            {innerNestedChildren.unit}
                                                                                        </Typography>
                                                                                    ) : null}
                                                                                </Box>
                                                                            </Box>
                                                                        ))}
                                                                    </>
                                                                ) : (
                                                                    <Box
                                                                        key={`${nestedChildren.fieldKey}-${nestedIndex}`}
                                                                        sx={{
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            mt: 0.5,
                                                                            width: '100%'
                                                                        }}
                                                                    >
                                                                        <Box sx={{ width: '150px', minWidth: '150px', maxWidth: '150px', pr: 1, flexShrink: 0 }}>
                                                                            <Typography textAlign='left' fontWeight="300" lineHeight={1.2} sx={{ fontSize: '11px', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>
                                                                                {nestedChildren.fieldName}
                                                                            </Typography>
                                                                        </Box>
                                                                        <Box sx={{ width: '150px', minWidth: '150px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                            {renderFieldControl({
                                                                                val: nestedChildren,
                                                                                fieldValue: findFieldValue(test.values, nestedChildren.fieldKey),
                                                                                edit: edit && (!val?.options?.includes('Positive') ? true : fieldValue === 'Positive'),
                                                                                onValueChange: (newVal) => setNestedChildValueByKey(test.id, nestedChildren.fieldKey, newVal)
                                                                            })}
                                                                        </Box>
                                                                        <Box sx={{ minWidth: '35px', pl: 0.5, display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexShrink: 0 }}>
                                                                            {nestedChildren.unit ? (
                                                                                <Typography sx={{ fontSize: '11px', fontWeight: '300', whiteSpace: 'nowrap' }}>
                                                                                    {nestedChildren.unit}
                                                                                </Typography>
                                                                            ) : null}
                                                                        </Box>
                                                                    </Box>
                                                                )}
                                                            </Box>
                                                        );
                                                    })}
                                                </Box>
                                            )}
                                        </React.Fragment>
                                    );
                                })}
                            </Box>
                            {
                                !edit && <Box justifySelf={'flex-end'} sx={{ marginBottom: 1, marginRight: 1, height: '3px' }}>
                                </Box>
                            }
                        </CardContent>
                        {edit && <Box
                            sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                padding: 1,
                                marginTop: "auto",
                            }}
                        >
                            {test.submitted ? <Typography
                                sx={{ height: '19px',px:2, fontSize: '9px', backgroundColor: 'rgba(134, 144, 148, 0.6)', color: '#FFF', borderRadius: '5px', alignContent: 'center' }}>
                                SUBMITTED
                            </Typography> : <Button
                                variant="contained"
                                onClick={async () => {
                                    setTests((prevState) => {
                                        let updated = [...prevState]
                                        const entryIndex = updated.findIndex(entry => entry.id === test.id)
                                        updated[entryIndex].submitted = true
                                        return updated
                                    })
                                    const payload = {
                                        values: test.values,
                                        labName: test.labName,
                                    };
                                    store.dispatch(patientActions.submitPatientTestsRequestAction(test.id, payload))
                                }}
                                sx={{ height: '19px', width: '58px', fontSize: '9px', backgroundColor: '#F27704' }}
                            >
                                Submit
                            </Button>}
                        </Box>}
                    </Card>
                ) : (
                    <TableContainer component={Paper} sx={getTableContainerSx(test, isMobile, { width: 'fit-content' })}>
                        <Box
                            sx={{
                                position: "absolute",
                                top: 10,
                                right: 10,
                                zIndex: 10,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            {test?.fileMediaId ? (
                                <Tooltip title="Click here to view the report">
                                    <IconButton
                                        onClick={() => handleView(test?.fileMediaId)}
                                        size="small"
                                        sx={{
                                            p: 0,
                                            width: 20,
                                            height: 20,
                                        }}
                                    >
                                        <PreviewIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            ) : uploadingMap[test.id] ? (
                                <CircularProgress size={18} />
                            ) : (
                                <Tooltip title="Click here to upload the report">
                                    <IconButton
                                        onClick={() => handleClick(test.id)}
                                        size="small"
                                        sx={{
                                            p: 0,
                                            width: 20,
                                            height: 20,
                                        }}
                                    >
                                        <UploadFileIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            )}
                            {edit && <DeleteTestButton test={test} onDeleted={refreshTests} />}
                        </Box>
                        <Table aria-label={`${test.testName} Test Results`} style={{ width: isMobile ? 'max-content' : 'fit-content', tableLayout: 'auto' }}>
                            <colgroup>
                                <col style={{ width: isMobile ? '150px' : '130px', minWidth: isMobile ? '150px' : '130px' }} />
                                {Array.from({ length: 1 + (test?.repeats?.length || 0) }).map((_, i) => (
                                    <col key={i} style={{ width: isMobile ? '150px' : '120px', minWidth: isMobile ? '150px' : '120px' }} />
                                ))}
                            </colgroup>
                            <TableHead>
                                <TableRow>
                                    <TableCell colSpan={1 + (1 + (test?.repeats?.length || 0))} sx={{ ...rowStyle, fontWeight: 'bold', py: 1, fontSize: '12px' }}>
                                        {renderTestName(test)}
                                    </TableCell>
                                </TableRow>
                                <TableRow sx={rowStyle}>
                                    <TableCell sx={{ ...rowStyle, fontWeight: '500' }}>Lab Name</TableCell>
                                    <TableCell sx={{ ...rowStyle, textAlign: 'center', px: 0.5 }}>
                                        <CustomTextField
                                            value={test.labName || ''}
                                            setValue={(newLabName) => setLabName(test.id, newLabName)}
                                            edit={edit}
                                            placeholder="Lab Name"
                                            width="100%"
                                        />
                                    </TableCell>
                                    {test?.repeats?.map((week, index) => (
                                        <TableCell key={index} sx={{ ...rowStyle, textAlign: 'center', fontWeight: '500' }}>
                                            {week.labName || '-'}
                                        </TableCell>
                                    ))}
                                    <input
                                        type="file"
                                        ref={(el) => (fileInputRefs.current[test.id] = el)}
                                        hidden
                                        accept="application/pdf"
                                        onChange={(e) => handleFileChange(e, test.id)}
                                    />
                                </TableRow>
                                <TableRow sx={{ ...rowStyle }}>
                                    <TableCell sx={{ ...rowStyle, fontWeight: '500' }}>{patientType === "GYNECOLOGY" ? "Date" : "Week"}</TableCell>
                                    <TableCell sx={{ ...rowStyle, py: 0.5, textAlign: 'center', fontWeight: '500' }}>
                                        {patientType !== "GYNECOLOGY" ? formatWeeks(test.week) : moment(test.updatedAt).format('DD-MM-YYYY')}
                                    </TableCell>
                                    {test?.repeats?.map((week, index) => (
                                        <TableCell key={index} sx={{ ...rowStyle, py: 0.5, textAlign: 'center', fontWeight: '500' }}>
                                            {patientType !== "GYNECOLOGY" ? formatWeeks(week.week) : moment(week.updatedAt).format('DD-MM-YYYY')}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(test?.tenantTest?.fields)?.map((val, index) => {
                                    const fieldValue = test?.values?.find(v => v.fieldKey === val.fieldKey)?.value || '';
                                    return (
                                        <React.Fragment key={index}>
                                            <TableRow sx={rowStyle}>
                                                <TableCell sx={{ ...rowStyle, fontWeight: '400' }}>
                                                    <ReferenceRange printed={test?.referenceRange?.[val.fieldKey]} template={val.referenceRange}>
                                                        <Typography sx={{ fontSize: '11px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                            {val.fieldName}
                                                        </Typography>
                                                    </ReferenceRange>
                                                </TableCell>

                                                {/* Main Test Column Cell (Column 1) */}
                                                <TableCell sx={{ ...rowStyle, textAlign: 'center', px: 0.5 }}>
                                                    {(val?.children?.length ?? 0) === 0 ? (
                                                        renderFieldControl({
                                                            val,
                                                            fieldValue,
                                                            edit,
                                                            onValueChange: (newVal) => setValue(test.id, val.fieldKey, newVal)
                                                        })
                                                    ) : (
                                                        <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%', gap: 0.5, justifyContent: 'center' }}>
                                                            {val.fieldType === 'OBJECT' && (val?.children || []).map((child, idx) => (
                                                                <Box
                                                                    key={`${child.fieldKey}-${idx}`}
                                                                    sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1, minWidth: 0 }}
                                                                >
                                                                    <ReferenceRange printed={test?.referenceRange?.[child.fieldKey]} template={child.referenceRange}>
                                                                        <Tooltip title={child.fieldName}>
                                                                            <Typography sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '10px', maxWidth: '100%' }}>
                                                                                {child.fieldName}
                                                                            </Typography>
                                                                        </Tooltip>
                                                                    </ReferenceRange>
                                                                    <CustomTextField
                                                                        value={findFieldValue(test.values, child.fieldKey) || ''}
                                                                        setValue={(childrenValue) => setChildrenValues(childrenValue, test.id, val.fieldKey, child.fieldKey)}
                                                                        edit={edit}
                                                                        width="100%"
                                                                    />
                                                                </Box>
                                                            ))}
                                                            {val.fieldType !== 'OBJECT' && renderFieldControl({
                                                                val,
                                                                fieldValue,
                                                                edit,
                                                                onValueChange: (newVal) => setValue(test.id, val.fieldKey, newVal)
                                                            })}
                                                        </Box>
                                                    )}
                                                </TableCell>

                                                {/* Repeat Test Columns Cells (Columns 2..N) */}
                                                {test?.repeats?.map((week, i) => {
                                                    const repeatTest = week?.values?.find(item => item.fieldKey === val.fieldKey);
                                                    return (
                                                        <TableCell key={i} sx={{ ...rowStyle, textAlign: 'center', px: 0.5 }}>
                                                            {(val?.children?.length ?? 0) === 0 ? (
                                                                renderFieldControl({
                                                                    val,
                                                                    fieldValue: repeatTest?.value,
                                                                    edit: false,
                                                                    onValueChange: null
                                                                })
                                                            ) : (
                                                                <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%', gap: 0.5, justifyContent: 'center' }}>
                                                                    {val.fieldType === 'OBJECT' && (val?.children || []).map((child, idx) => (
                                                                        <Box
                                                                            key={`${child.fieldKey}-${idx}`}
                                                                            sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1, minWidth: 0 }}
                                                                        >
                                                                            <ReferenceRange printed={week?.referenceRange?.[child.fieldKey]} template={child.referenceRange}>
                                                                                <Typography variant="caption" fontWeight="bold" sx={{ fontSize: '10px' }}>
                                                                                    {child.fieldName}
                                                                                </Typography>
                                                                            </ReferenceRange>
                                                                            <CustomTextField
                                                                                value={findFieldValue(week.values, child.fieldKey) || ''}
                                                                                edit={false}
                                                                                width="100%"
                                                                            />
                                                                        </Box>
                                                                    ))}
                                                                    {val.fieldType !== 'OBJECT' && renderFieldControl({
                                                                        val,
                                                                        fieldValue: repeatTest?.value,
                                                                        edit: false,
                                                                        onValueChange: null
                                                                    })}
                                                                </Box>
                                                            )}
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>

                                            {/* Nested rows / child fields (for non-OBJECT fields) */}
                                            {val.fieldType !== 'OBJECT' && (val?.children || []).map((nestedChildren, nestedIndex) => {
                                                const hasSubChildren = (nestedChildren?.children || []).length > 0;
                                                return (
                                                    <React.Fragment key={`nested-group-${nestedIndex}`}>
                                                        {nestedChildren.fieldName && hasSubChildren && (
                                                            <TableRow sx={rowStyle}>
                                                                <TableCell colSpan={1 + 1 + (test?.repeats?.length || 0)} sx={{ ...rowStyle, pl: 2, pt: 1, pb: 0.2 }}>
                                                                    <Typography sx={{ fontSize: '11px', color: '#333' }}>
                                                                        {nestedChildren.fieldName}
                                                                    </Typography>
                                                                </TableCell>
                                                            </TableRow>
                                                        )}
                                                        {hasSubChildren ? (
                                                            nestedChildren.children.map((innerNestedChildren, innerNestedIndex) => (
                                                                <TableRow key={`nested-${nestedIndex}-${innerNestedIndex}`} sx={rowStyle}>
                                                                    <TableCell sx={{ ...rowStyle, pl: 2 }}>
                                                                        <Typography sx={{ fontSize: '11px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                            {innerNestedChildren.fieldName}
                                                                        </Typography>
                                                                    </TableCell>
                                                                    <TableCell sx={{ ...rowStyle, textAlign: 'center', px: 0.5 }}>
                                                                        {renderFieldControl({
                                                                            val: innerNestedChildren,
                                                                            fieldValue: findFieldValue(test.values, innerNestedChildren.fieldKey),
                                                                            edit: edit && (!val?.options?.includes('Positive') ? true : fieldValue === 'Positive'),
                                                                            onValueChange: (newVal) => setNestedChildValueByKey(test.id, innerNestedChildren.fieldKey, newVal)
                                                                        })}
                                                                    </TableCell>
                                                                    {test?.repeats?.map((repeatTest, i) => (
                                                                        <TableCell key={i} sx={{ ...rowStyle, textAlign: 'center', px: 0.5 }}>
                                                                            {renderFieldControl({
                                                                                val: innerNestedChildren,
                                                                                fieldValue: findFieldValue(repeatTest.values, innerNestedChildren.fieldKey),
                                                                                edit: false,
                                                                                onValueChange: null
                                                                            })}
                                                                        </TableCell>
                                                                    ))}
                                                                </TableRow>
                                                            ))
                                                        ) : (
                                                            <TableRow key={`nested-direct-${nestedIndex}`} sx={rowStyle}>
                                                                <TableCell sx={{ ...rowStyle, pl: 2 }}>
                                                                    <Typography sx={{ fontSize: '11px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                        {nestedChildren.fieldName}
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell sx={{ ...rowStyle, textAlign: 'center', px: 0.5 }}>
                                                                    {renderFieldControl({
                                                                        val: nestedChildren,
                                                                        fieldValue: findFieldValue(test.values, nestedChildren.fieldKey),
                                                                        edit: edit && (!val?.options?.includes('Positive') ? true : fieldValue === 'Positive'),
                                                                        onValueChange: (newVal) => setNestedChildValueByKey(test.id, nestedChildren.fieldKey, newVal)
                                                                    })}
                                                                </TableCell>
                                                                {test?.repeats?.map((repeatTest, i) => (
                                                                    <TableCell key={i} sx={{ ...rowStyle, textAlign: 'center', px: 0.5 }}>
                                                                        {renderFieldControl({
                                                                            val: nestedChildren,
                                                                            fieldValue: findFieldValue(repeatTest.values, nestedChildren.fieldKey),
                                                                            edit: false,
                                                                            onValueChange: null
                                                                        })}
                                                                    </TableCell>
                                                                ))}
                                                            </TableRow>
                                                        )}
                                                    </React.Fragment>
                                                );
                                            })}
                                        </React.Fragment>
                                    );
                                })}
                            </TableBody>

                        </Table>
                        {
                            edit && <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 'auto', mb: 1, mr: 1, pt: 1 }}>
                                {test.submitted ? <Typography
                                    sx={{ height: '19px',px:2,  fontSize: '9px', backgroundColor: 'rgba(134, 144, 148, 0.6)', color: '#FFF', borderRadius: '5px', alignContent: 'center' }}>
                                    SUBMITTED
                                </Typography> : <Button
                                    variant="contained"
                                    onClick={() => {
                                        setTests((prevState) => {
                                            let updated = [...prevState]
                                            const entryIndex = updated.findIndex(entry => entry.id === test.id)
                                            updated[entryIndex].submitted = true
                                            return updated
                                        })
                                        store.dispatch(patientActions.submitPatientTestsRequestAction(test.id, {
                                            values: test.values,
                                            "labName": test.labName
                                        }))
                                    }}

                                    sx={{ height: '19px', width: '58px', fontSize: '9px', backgroundColor: '#F27704' }}
                                >
                                    Submit
                                </Button>
                                }
                            </Box>
                        }

                        {
                            !edit && <Box justifySelf={'flex-end'} sx={{ marginBottom: 1, marginRight: 1, height: '3px' }}>
                            </Box>
                        }

                    </TableContainer>
                ))
            )
                :
                customTest?.length == 0 && <Typography>No tests this week</Typography>
            }


        </Box>
    );

    const isPageLoading = loader || patientReducer?.status === patientActionStatus.GET_PATIENT_TESTS_REQUEST || !patientReducer?.tests;

    return (
        <>
            <CommonGate />
            <Box sx={{
                width: '100%',
                overflowX: 'hidden',
                px: { xs: 0.5, md: 0 },
                height: { xs: 'auto', md: '60vh', lg: '73vh', xl: '70vh' },
            }}>
                {!isPageLoading ? <>
                    {testsNeedingApproval.length > 0 && (
                        <Box sx={{  display: 'flex', justifyContent: 'flex-end', marginRight:2 }}>
                            <Button
                                variant="contained"
                                
                                onClick={() => setApprovalModalOpen(true)}
                                sx={{ textTransform: 'none', borderRadius: 2 , backgroundColor:'#F27704', fontSize:'15px', fontWeight:'600'}}
                            >
                                {testsNeedingApproval.length} tests need approval
                            </Button>
                        </Box>
                    )}
                    <TestApprovalModal
                        open={approvalModalOpen}
                        onClose={() => setApprovalModalOpen(false)}
                        pendingTests={testsNeedingApproval}
                        patientId={patientId}
                        isMobile={isMobile}
                        patientType={patientType}
                    />

                    {(edit && hasPermission("TEST_CREATE")) && <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', }}>
                        <AsyncCreatableSelect
                            cacheOptions
                            defaultOptions={false}
                            loadOptions={loadAdditionalTestOptions}
                            placeholder="Add Test"
                            value={selectedAdditionalTest}
                            onChange={(selectedOption) => {
                                if (!selectedOption) return;

                                const alreadyExists =
                                    tests?.some(
                                        (test) =>
                                            test.id === selectedOption.id
                                    );

                                if (!alreadyExists) {
                                    const formattedTest = {
                                        ...selectedOption,
                                        customValue: moment(),
                                        submitted: false,
                                        values: (selectedOption.fields || []).map((field) => ({
                                            id: field.id,
                                            unit: field.unit || null,
                                            value: "",
                                            fieldName: field.fieldName,
                                            fieldKey: field.fieldKey,
                                            fieldType: field.fieldType,
                                            children: field.children || [],
                                            isParent: true,
                                        })),
                                    };

                                    setCustomTestFormat((prevState) => {
                                        return [formattedTest, ...prevState];
                                    });
                                }

                                setSelectedAdditionalTest(null);
                            }}

                            onCreateOption={async (inputValue) => {
                                try {
                                    const payload = {
                                        patientId,
                                        consultationId,
                                        testName: inputValue,
                                        customValue: null,
                                        category: "Other",
                                    };

                                    const response = await API.post(
                                        "/v1/tests/custom",
                                        payload
                                    );

                                    if (!response.success) {
                                        return;
                                    }
                                    const createdTest = response.data;
                                    const formattedTest = {
                                        ...createdTest,
                                        customValue: moment(),
                                        submitted: false,
                                        values: (createdTest.fields || []).map((field) => ({
                                            id: field.id,
                                            unit: field.unit || null,
                                            value: "",
                                            fieldName: field.fieldName,
                                            fieldKey: field.fieldKey,
                                            fieldType: field.fieldType,
                                            children: field.children || [],
                                            isParent: true,

                                        })),
                                    };

                                    setCustomTestFormat((prevState) => {
                                        return [formattedTest, ...prevState];
                                    });

                                } catch (error) {
                                    console.error("Error creating custom test:", error);
                                }
                            }}
                            styles={{
                                ...styles.asyncSelect,
                                container: (base) => ({
                                    ...base,
                                    width: isMobile ? '100%' : '159px',
                                    marginLeft: isMobile ? '0' : '15px'
                                }),
                                menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 10000
                                })
                            }}
                            menuPortalTarget={document.body}
                        />
                    </Box>}

                    <Box sx={{ width: '100%', marginBottom: { xl: 15, lg: 10, } }}>
                        <Timeline
                            position="left"
                            sx={{
                                [`& .${timelineItemClasses.root}:before`]: {
                                    flex: 0,
                                    padding: 0,
                                },
                                padding: { xs: 0, md: '6px 16px' },
                                margin: 0
                            }}
                        >
                                <TimelineItem ref={currentTestsRef}>
                                    <TimelineSeparator>
                                        <TimelineDot sx={{ bgcolor: '#FFCA67', margin: '14px 0' }} />
                                        {pastTests.length > 0 && <TimelineConnector sx={{ bgcolor: '#FFCA67' }} />}
                                    </TimelineSeparator>
                                    <TimelineContent sx={{ pb: 3, px: { xs: 1, md: 2 }, minWidth: 0 }}>
                                        <Typography variant="h6" fontWeight="bold" mb={2} textAlign={'left'}
                                            style={{
                                                backgroundColor: '#FFF',
                                                borderRadius: 5,
                                                display: 'inline-block'
                                            }} sx={{
                                                fontSize: { xs: '12px', md: '16px' },
                                            }}>
                                            Current Tests
                                        </Typography>
                                        {testsScrollContent}
                                    </TimelineContent>
                                </TimelineItem>

                            {pastTests.length > 0 && pastTests.map((test, pastTestIndex) => {
                                return (
                                    <TimelineItem key={pastTestIndex} ref={pastTestIndex === 0 ? selectedWeekRef : null}>
                                        <TimelineSeparator>
                                            <TimelineDot sx={{ bgcolor: '#5681A6', margin: '14px 0' }} />
                                            {pastTestIndex < pastTests.length - 1 && <TimelineConnector sx={{ bgcolor: '#5681A6' }} />}
                                        </TimelineSeparator>
                                        <TimelineContent sx={{ pb: 3, px: { xs: 1, md: 2 }, minWidth: 0 }}>
                                            <Typography variant="h6" fontWeight="bold" mb={2} textAlign={'left'}
                                                style={{
                                                    backgroundColor: '#FFF',
                                                    borderRadius: 5,
                                                    display: 'inline-block'
                                                }} sx={{
                                                    fontSize: { xs: '12px', md: '16px' },
                                                }}>
                                                {patientType !== "GYNECOLOGY" ? formatWeeks(test.week) : moment(test.updatedAt).format('DD-MM-YYYY')}
                                            </Typography>

                                            <Box sx={{
                                                display: "flex",
                                                flexWrap: "wrap",
                                                gap: { xs: 1, md: 0.5 },
                                                flexDirection: { xs: 'column', sm: 'row' },
                                                width: '100%',
                                                minWidth: 0,
                                            }}>
                                                {test?.tests?.length > 0 ? test.tests.map(test => (
                                                    !test.isRepeated ? (
                                                        <Card key={test.id} sx={{
                                                            ...styles.singleCard,
                                                            width: { xs: '100%', sm: 'fit-content' },
                                                            position: 'relative',
                                                            maxWidth: { xs: '100%', sm: '460px' }
                                                        }}>
                                                            <Box
                                                                sx={{
                                                                    position: "absolute",
                                                                    top: 10,
                                                                    right: 10,
                                                                    zIndex: 10,
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                }}
                                                            >
                                                                {test?.fileMediaId ? (
                                                                    <Tooltip title="Click here to view the report">
                                                                        <IconButton
                                                                            onClick={() => handleView(test?.fileMediaId)}
                                                                            size="small"
                                                                            sx={{
                                                                                p: 0,
                                                                                width: 20,
                                                                                height: 20,
                                                                            }}
                                                                        >
                                                                            <PreviewIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                ) : uploadingMap[test.id] ? (
                                                                    <CircularProgress size={18} />
                                                                ) : (
                                                                    <Tooltip title="Click here to upload the report">
                                                                        <IconButton
                                                                            onClick={() => handleClick(test.id)}
                                                                            size="small"
                                                                            sx={{
                                                                                p: 0,
                                                                                width: 20,
                                                                                height: 20,
                                                                            }}
                                                                        >
                                                                            <UploadFileIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                )}
                                                                {edit && <DeleteTestButton test={test} onDeleted={refreshTests} />}
                                                            </Box>
                                                            <CardContent sx={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                flex: 1,
                                                            }}>
                                                                <input
                                                                    type="file"
                                                                    ref={(el) => (fileInputRefs.current[test.id] = el)}
                                                                    hidden
                                                                    onChange={(e) => handleFileChange(e, test.id)}
                                                                />
                                                                <Box display="flex" justifyContent="space-between" mb={1}>
                                                                    {renderTestName(test, true)}
                                                                </Box>
                                                                {(
                                                                     <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                                                         <Box sx={{ width: '150px', minWidth: '150px', maxWidth: '150px', pr: 1, flexShrink: 0 }}>
                                                                             <Typography textAlign='left' fontWeight="300" lineHeight={1.2} sx={{ fontSize: '11px' }}>
                                                                                 Lab Name
                                                                             </Typography>
                                                                         </Box>
                                                                         <Box sx={{ width: '150px', minWidth: '150px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                             <CustomTextField
                                                                                 value={test.labName || ''}
                                                                                 setValue={(newLabName) => setPastLabName(test.id, newLabName, pastTestIndex)}
                                                                                 edit={edit}
                                                                                 placeholder="Lab Name"
                                                                                 width="100%"
                                                                             />
                                                                         </Box>
                                                                         <Box sx={{ minWidth: '35px', pl: 0.5, flexShrink: 0 }} />
                                                                     </Box>
                                                                )}
                                                                <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }} mt={0.5}>
                                                                    <Box sx={{ width: '150px', minWidth: '150px', maxWidth: '150px', pr: 1, flexShrink: 0 }}>
                                                                        <Typography textAlign='left' fontWeight="300" lineHeight={1.2} sx={{ fontSize: '11px' }}>
                                                                            {patientType == "GYNECOLOGY" ? "Date" : "Week"}
                                                                        </Typography>
                                                                    </Box>
                                                                    <Box sx={{ width: '150px', minWidth: '150px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                        <Typography textAlign='center' sx={{ fontSize: '11px' }}>
                                                                            {patientType !== "GYNECOLOGY" ? formatWeeks(test.week) : moment(test.updatedAt).format('DD-MM-YYYY')}
                                                                        </Typography>
                                                                    </Box>
                                                                    <Box sx={{ minWidth: '35px', pl: 0.5, flexShrink: 0 }} />
                                                                </Box>
                                                                <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 1 }}>
                                                                    {test?.tenantTest?.fields?.length > 0 && test.tenantTest.fields.map((val, index) => {
                                                                        const fieldValue = test?.values?.find(v => v.fieldKey === val.fieldKey)?.value || '';
                                                                        return (
                                                                            <React.Fragment key={index}>
                                                                                {val.fieldType === 'OBJECT' && (val?.children || []).map((child, idx) => (
                                                                                    <Box
                                                                                        key={`${child.fieldKey}-${idx}`}
                                                                                        sx={{
                                                                                            display: "flex",
                                                                                            alignItems: "center",
                                                                                            width: '100%',
                                                                                            mt: 0.5
                                                                                        }}
                                                                                    >
                                                                                        <Box sx={{ width: '150px', minWidth: '150px', maxWidth: '150px', pr: 1, flexShrink: 0 }}>
                                                                                            <ReferenceRange printed={test?.referenceRange?.[child.fieldKey]} template={child.referenceRange}>
                                                                                                <Typography textAlign='left' fontWeight="300" lineHeight={1.2} sx={{ fontSize: '11px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                                                    {child.fieldName}
                                                                                                </Typography>
                                                                                            </ReferenceRange>
                                                                                        </Box>
                                                                                        <Box sx={{ width: '150px', minWidth: '150px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                                            <CustomTextField
                                                                                                value={findFieldValue(test.values, child.fieldKey) || ''}
                                                                                                setValue={(childrenValue) => setPastChildrenValues(childrenValue, test.id, val.fieldKey, child.fieldKey, pastTestIndex)}
                                                                                                edit={edit}
                                                                                                width="100%"
                                                                                            />
                                                                                        </Box>
                                                                                        <Box sx={{ width: { xs: '40px', sm: '60px' }, pl: 0.5 }} />
                                                                                    </Box>
                                                                                ))}
                                                                                {val.fieldType !== 'OBJECT' && (
                                                                                    <Box
                                                                                        sx={{
                                                                                            display: "flex",
                                                                                            alignItems: "center",
                                                                                            width: '100%',
                                                                                        }}
                                                                                    >
                                                                                        <Box sx={{ width: '150px', minWidth: '150px', maxWidth: '150px', pr: 1, flexShrink: 0 }}>
                                                                                            <ReferenceRange printed={test?.referenceRange?.[val.fieldKey]} template={val.referenceRange}>
                                                                                                <Typography textAlign='left' fontWeight="300" lineHeight={1.2} sx={{ fontSize: '11px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                                                    {val.fieldName}
                                                                                                </Typography>
                                                                                            </ReferenceRange>
                                                                                        </Box>
                                                                                        <Box sx={{ width: '150px', minWidth: '150px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                                            {renderFieldControl({
                                                                                                val,
                                                                                                fieldValue,
                                                                                                edit,
                                                                                                onValueChange: (value) => setPastTestValue(test.id, val.fieldKey, value, test.week)
                                                                                            })}
                                                                                        </Box>
                                                                                        <Box sx={{ width: { xs: '40px', sm: '60px' }, pl: 0.5, display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexShrink: 0 }}>
                                                                                            {val.unit ? (
                                                                                                <Typography sx={{ fontSize: '11px', fontWeight: '300', whiteSpace: 'nowrap' }}>
                                                                                                    {val.unit}
                                                                                                </Typography>
                                                                                            ) : null}
                                                                                        </Box>
                                                                                    </Box>
                                                                                )}
                                                                                {val.fieldType !== 'OBJECT' && (val?.children?.length ?? 0) > 0 && (
                                                                                    <Box sx={{ width: '100%', mt: 0.5 }}>
                                                                                        {(val?.children || []).map((nestedChildren, nestedIndex) => {
                                                                                            const hasSubChildren = (nestedChildren?.children || []).length > 0;
                                                                                            return (
                                                                                                <Box key={nestedIndex} sx={{ mt: 0.5 }}>
                                                                                                    {hasSubChildren ? (
                                                                                                        <>
                                                                                                            {nestedChildren.fieldName && (
                                                                                                                <Typography textAlign='left' fontWeight="400" lineHeight={1} sx={{ fontSize: '11px', mb: 0.5 }}>
                                                                                                                    {nestedChildren.fieldName}
                                                                                                                </Typography>
                                                                                                            )}
                                                                                                            {(nestedChildren?.children || []).map((innerNestedChildren, innerNestedIndex) => (
                                                                                                                <Box
                                                                                                                    key={`${innerNestedChildren.fieldKey}-${innerNestedIndex}`}
                                                                                                                    sx={{
                                                                                                                        display: "flex",
                                                                                                                        alignItems: "center",
                                                                                                                        mt: 0.5,
                                                                                                                        width: '100%'
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <Box sx={{ width: '150px', minWidth: '150px', maxWidth: '150px', pr: 1, flexShrink: 0 }}>
                                                                                                                        <Typography textAlign='left' fontWeight="300" lineHeight={1.2} sx={{ fontSize: '11px', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>
                                                                                                                            {innerNestedChildren.fieldName}
                                                                                                                        </Typography>
                                                                                                                    </Box>
                                                                                                                    <Box sx={{ width: '150px', minWidth: '150px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                                                                        {renderFieldControl({
                                                                                                                            val: innerNestedChildren,
                                                                                                                            fieldValue: findFieldValue(test.values, innerNestedChildren.fieldKey),
                                                                                                                            edit: edit && (!val?.options?.includes('Positive') ? true : fieldValue === 'Positive'),
                                                                                                                            onValueChange: (newVal) => setPastNestedChildValueByKey(test.id, innerNestedChildren.fieldKey, newVal, pastTestIndex)
                                                                                                                        })}
                                                                                                                    </Box>
                                                                                                                    <Box sx={{ width: { xs: '40px', sm: '60px' }, pl: 0.5 }} />
                                                                                                                </Box>
                                                                                                            ))}
                                                                                                        </>
                                                                                                    ) : (
                                                                                                        <Box
                                                                                                            key={`${nestedChildren.fieldKey}-${nestedIndex}`}
                                                                                                            sx={{
                                                                                                                display: "flex",
                                                                                                                alignItems: "center",
                                                                                                                mt: 0.5,
                                                                                                                width: '100%'
                                                                                                            }}
                                                                                                        >
                                                                                                             <Box sx={{ width: '150px', minWidth: '150px', pr: 0.5, flexShrink: 0 }}>
                                                                                                                <Typography textAlign='left' fontWeight="300" lineHeight={1.2} sx={{ fontSize: '11px', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>
                                                                                                                    {nestedChildren.fieldName}
                                                                                                                </Typography>
                                                                                                            </Box>
                                                                                                            <Box sx={{ width: { xs: 'auto', sm: '130px' }, flex: { xs: 1, sm: 'none' }, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                                                                {renderFieldControl({
                                                                                                                    val: nestedChildren,
                                                                                                                    fieldValue: findFieldValue(test.values, nestedChildren.fieldKey),
                                                                                                                    edit: edit && (!val?.options?.includes('Positive') ? true : fieldValue === 'Positive'),
                                                                                                                    onValueChange: (newVal) => setPastNestedChildValueByKey(test.id, nestedChildren.fieldKey, newVal, pastTestIndex)
                                                                                                                })}
                                                                                                            </Box>
                                                                                                            <Box sx={{ minWidth: '40px', pl: 0.5, display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexShrink: 0 }}>
                                                                                                                {nestedChildren.unit ? (
                                                                                                                    <Typography sx={{ fontSize: '11px', fontWeight: '300', whiteSpace: 'nowrap' }}>
                                                                                                                        {nestedChildren.unit}
                                                                                                                    </Typography>
                                                                                                                ) : null}
                                                                                                            </Box>
                                                                                                        </Box>
                                                                                                    )}
                                                                                                </Box>
                                                                                            );
                                                                                        })}
                                                                                    </Box>
                                                                                )}
                                                                            </React.Fragment>
                                                                        );
                                                                    })}
                                                                </Box>
                                                                {
                                                                    !edit && <Box justifySelf={'flex-end'} sx={{ marginBottom: 1, marginRight: 1, height: '3px' }}>
                                                                    </Box>
                                                                }
                                                            </CardContent>
                                                            {edit && <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    justifyContent: "flex-end",
                                                                    padding: 1,
                                                                    marginTop: "auto",
                                                                }}
                                                            >
                                                                {test.submitted ? <Typography
                                                                    sx={{ height: '19px',px:2,  fontSize: '9px', backgroundColor: 'rgba(134, 144, 148, 0.6)', color: '#FFF', borderRadius: '5px', alignContent: 'center' }}>
                                                                    SUBMITTED
                                                                </Typography> : <Button
                                                                    variant="contained"
                                                                    onClick={() => {
                                                                        setPastTests((prevState) => {
                                                                            return prevState.map(preTest => ({
                                                                                ...preTest,
                                                                                tests: preTest.tests.map(testItem => {
                                                                                    if (testItem.id === test.id) {
                                                                                        return {
                                                                                            ...testItem,
                                                                                            submitted: true
                                                                                        };
                                                                                    }
                                                                                    return testItem;
                                                                                })
                                                                            }));
                                                                        });
                                                                        store.dispatch(patientActions.submitPatientTestsRequestAction(test.id, {
                                                                            values: test.values,
                                                                            "labName": test.labName
                                                                        }))
                                                                    }}
                                                                    sx={{ height: '19px', width: '58px', fontSize: '9px', backgroundColor: '#F27704' }}
                                                                >
                                                                    Submit
                                                                </Button>}
                                                            </Box>}
                                                        </Card>
                                                    ) : (

                                                        <TableContainer component={Paper} sx={getTableContainerSx(test, isMobile, { past: true })}>
                                                            <Box
                                                                sx={{
                                                                    position: "absolute",
                                                                    top: 10,
                                                                    right: 10,
                                                                    zIndex: 10,
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                }}
                                                            >
                                                                {test?.fileMediaId ? (
                                                                    <Tooltip title="Click here to view the report">
                                                                        <IconButton
                                                                            onClick={() => handleView(test?.fileMediaId)}
                                                                            size="small"
                                                                            sx={{
                                                                                p: 0,
                                                                                width: 20,
                                                                                height: 20,
                                                                            }}
                                                                        >
                                                                            <PreviewIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                ) : uploadingMap[test.id] ? (
                                                                    <CircularProgress size={18} />
                                                                ) : (
                                                                    <Tooltip title="Click here to upload the report">
                                                                        <IconButton
                                                                            onClick={() => handleClick(test.id)}
                                                                            size="small"
                                                                            sx={{
                                                                                p: 0,
                                                                                width: 20,
                                                                                height: 20,
                                                                            }}
                                                                        >
                                                                            <UploadFileIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                )}
                                                                {edit && <DeleteTestButton test={test} onDeleted={refreshTests} />}
                                                            </Box>
                                                            <Table aria-label={`${test.testName} Past Test Results`} style={{ width: isMobile ? 'max-content' : '100%', tableLayout: isMobile ? 'auto' : 'fixed' }}>
                                                                <colgroup>
                                                                    <col style={{ width: isMobile ? '150px' : '130px', minWidth: isMobile ? '150px' : '130px' }} />
                                                                    {Array.from({ length: 1 + (test?.repeats?.length || 0) }).map((_, i) => (
                                                                        <col key={i} style={{ width: isMobile ? '150px' : '120px', minWidth: isMobile ? '150px' : '120px' }} />
                                                                    ))}
                                                                </colgroup>
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell colSpan={1 + (1 + (test?.repeats?.length || 0))} sx={{ ...rowStyle, fontWeight: 'bold', py: 1, fontSize: '12px' }}>
                                                                            {renderTestName(test)}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                    <TableRow sx={rowStyle}>
                                                                        <TableCell sx={{ ...rowStyle, fontWeight: 600 }}>Lab Name</TableCell>
                                                                        <TableCell sx={{ ...rowStyle, textAlign: 'center', px: 0.5 }}>
                                                                            <CustomTextField
                                                                                value={test.labName || ''}
                                                                                setValue={(newLabName) => setPastLabName(test.id, newLabName, pastTestIndex)}
                                                                                edit={edit}
                                                                                placeholder="Lab Name"
                                                                                width="100%"
                                                                            />
                                                                        </TableCell>
                                                                        {test?.repeats.map((week, index) => (
                                                                            <TableCell key={index} sx={{ ...rowStyle, textAlign: 'center', fontWeight: 600 }}>
                                                                                {week.labName || '-'}
                                                                            </TableCell>
                                                                        ))}
                                                                        <input
                                                                            type="file"
                                                                            ref={(el) => (fileInputRefs.current[test.id] = el)}
                                                                            hidden
                                                                            accept="application/pdf"
                                                                            onChange={(e) => handleFileChange(e, test.id)}
                                                                        />
                                                                    </TableRow>
                                                                    <TableRow sx={rowStyle}>
                                                                        <TableCell sx={{ ...rowStyle, fontWeight: 600 }}>{patientType === "GYNECOLOGY" ? "Date" : "Week"}</TableCell>
                                                                        <TableCell sx={{ ...rowStyle, py: 0.5, textAlign: 'center' }}>
                                                                            {patientType !== "GYNECOLOGY" ? formatWeeks(test.week) : moment(test.updatedAt).format('DD-MM-YYYY')}
                                                                        </TableCell>
                                                                        {test?.repeats.map((week, index) => (
                                                                            <TableCell key={index} sx={{ ...rowStyle, py: 0.5, textAlign: 'center' }}>
                                                                                {patientType !== "GYNECOLOGY" ? formatWeeks(week.week) : moment(week.updatedAt).format('DD-MM-YYYY')}
                                                                            </TableCell>
                                                                        ))}
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {(test?.tenantTest?.fields || []).map((val, index) => {
                                                                        const fieldValue = test?.values?.find(v => v.fieldKey === val.fieldKey)?.value || '';
                                                                        return (
                                                                            <React.Fragment key={index}>
                                                                                <TableRow sx={rowStyle}>
                                                                                    <TableCell sx={rowStyle}>
                                                                                        <ReferenceRange printed={test?.referenceRange?.[val.fieldKey]} template={val.referenceRange}>
                                                                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                                                                <Typography sx={{ fontSize: '11px', fontWeight: 500 }}>
                                                                                                    {val.fieldName}
                                                                                                </Typography>
                                                                                                {val.unit && (
                                                                                                    <Typography sx={{ fontSize: '10px', color: '#666', ml: 0.5 }}>
                                                                                                        ({val.unit})
                                                                                                    </Typography>
                                                                                                )}
                                                                                            </Box>
                                                                                        </ReferenceRange>
                                                                                    </TableCell>
                                                                                    <TableCell sx={{ ...rowStyle, textAlign: 'center', px: 0.5 }}>
                                                                                        {(val?.children?.length ?? 0) === 0 ? (
                                                                                            renderFieldControl({
                                                                                                val,
                                                                                                fieldValue,
                                                                                                edit,
                                                                                                onValueChange: (value) => setPastTestValue(test.id, val.fieldKey, value, test.week)
                                                                                            })
                                                                                        ) : (
                                                                                            <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%', gap: 0.5, justifyContent: 'center' }}>
                                                                                                {val.fieldType === 'OBJECT' && (val?.children || []).map((child, idx) => (
                                                                                                    <Box
                                                                                                        key={`${child.fieldKey}-${idx}`}
                                                                                                        sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1, minWidth: 0 }}
                                                                                                    >
                                                                                                        <ReferenceRange printed={test?.referenceRange?.[child.fieldKey]} template={child.referenceRange}>
                                                                                                            <Tooltip title={child.fieldName}>
                                                                                                                <Typography sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '10px', maxWidth: '100%' }}>
                                                                                                                    {child.fieldName}
                                                                                                                </Typography>
                                                                                                            </Tooltip>
                                                                                                        </ReferenceRange>
                                                                                                        <CustomTextField
                                                                                                            value={findFieldValue(test.values, child.fieldKey) || ''}
                                                                                                            setValue={(childrenValue) => setPastChildrenValues(childrenValue, test.id, val.fieldKey, child.fieldKey, pastTestIndex)}
                                                                                                            edit={edit}
                                                                                                            width="100%"
                                                                                                        />
                                                                                                    </Box>
                                                                                                ))}
                                                                                                {val.fieldType !== 'OBJECT' && renderFieldControl({
                                                                                                    val,
                                                                                                    fieldValue,
                                                                                                    edit,
                                                                                                    onValueChange: (value) => setPastTestValue(test.id, val.fieldKey, value, test.week)
                                                                                                })}
                                                                                            </Box>
                                                                                        )}
                                                                                    </TableCell>
                                                                                    {test?.repeats.map((week, i) => {
                                                                                        const repeatTest = week?.values?.find(item => item.fieldKey === val.fieldKey);
                                                                                        return (
                                                                                            <TableCell key={i} sx={{ ...rowStyle, textAlign: 'center', px: 0.5 }}>
                                                                                                {(val?.children?.length ?? 0) === 0 ? (
                                                                                                    renderFieldControl({
                                                                                                        val,
                                                                                                        fieldValue: repeatTest?.value,
                                                                                                        edit: false,
                                                                                                        onValueChange: null
                                                                                                    })
                                                                                                ) : (
                                                                                                    <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%', gap: 0.5, justifyContent: 'center' }}>
                                                                                                        {val.fieldType === 'OBJECT' && (val?.children || []).map((child, idx) => (
                                                                                                            <Box
                                                                                                                key={`${child.fieldKey}-${idx}`}
                                                                                                                sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1, minWidth: 0 }}
                                                                                                            >
                                                                                                                <ReferenceRange printed={week?.referenceRange?.[child.fieldKey]} template={child.referenceRange}>
                                                                                                                    <Typography variant="caption" fontWeight="bold" sx={{ fontSize: '10px' }}>
                                                                                                                        {child.fieldName}
                                                                                                                    </Typography>
                                                                                                                </ReferenceRange>
                                                                                                                <CustomTextField
                                                                                                                    value={findFieldValue(week.values, child.fieldKey) || ''}
                                                                                                                    edit={false}
                                                                                                                    width="100%"
                                                                                                                />
                                                                                                            </Box>
                                                                                                        ))}
                                                                                                        {val.fieldType !== 'OBJECT' && renderFieldControl({
                                                                                                            val,
                                                                                                            fieldValue: repeatTest?.value,
                                                                                                            edit: false,
                                                                                                            onValueChange: null
                                                                                                        })}
                                                                                                    </Box>
                                                                                                )}
                                                                                            </TableCell>
                                                                                        );
                                                                                    })}
                                                                                </TableRow>
                                                                                {/* Nested rows / child fields (for non-OBJECT fields) */}
                                                                                {val.fieldType !== 'OBJECT' && (val?.children || []).map((nestedChildren, nestedIndex) => {
                                                                                    const hasSubChildren = (nestedChildren?.children || []).length > 0;
                                                                                    return (
                                                                                        <React.Fragment key={`nested-past-group-${nestedIndex}`}>
                                                                                            {nestedChildren.fieldName && hasSubChildren && (
                                                                                                <TableRow sx={rowStyle}>
                                                                                                    <TableCell colSpan={1 + 1 + (test?.repeats?.length || 0)} sx={{ ...rowStyle, pl: 2, pt: 1, pb: 0.2 }}>
                                                                                                        <Typography sx={{ fontSize: '11px', color: '#333' }}>
                                                                                                            {nestedChildren.fieldName}
                                                                                                        </Typography>
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                            )}
                                                                                            {hasSubChildren ? (
                                                                                                nestedChildren.children.map((innerNestedChildren, innerNestedIndex) => (
                                                                                                    <TableRow key={`nested-past-${nestedIndex}-${innerNestedIndex}`} sx={rowStyle}>
                                                                                                        <TableCell sx={{ ...rowStyle, pl: 2 }}>
                                                                                                            <Typography sx={{ fontSize: '11px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                                                                {innerNestedChildren.fieldName}
                                                                                                            </Typography>
                                                                                                        </TableCell>
                                                                                                        <TableCell sx={{ ...rowStyle, textAlign: 'center', px: 0.5 }}>
                                                                                                            {renderFieldControl({
                                                                                                                val: innerNestedChildren,
                                                                                                                fieldValue: findFieldValue(test.values, innerNestedChildren.fieldKey),
                                                                                                                edit: edit && (!val?.options?.includes('Positive') ? true : fieldValue === 'Positive'),
                                                                                                                onValueChange: (newVal) => setPastNestedChildValueByKey(test.id, innerNestedChildren.fieldKey, newVal, pastTestIndex)
                                                                                                            })}
                                                                                                        </TableCell>
                                                                                                        {test.repeats.map((repeatTest, rIdx) => (
                                                                                                            <TableCell key={rIdx} sx={{ ...rowStyle, textAlign: 'center', px: 0.5 }}>
                                                                                                                {renderFieldControl({
                                                                                                                    val: innerNestedChildren,
                                                                                                                    fieldValue: findFieldValue(repeatTest.values, innerNestedChildren.fieldKey),
                                                                                                                    edit: false,
                                                                                                                    onValueChange: null
                                                                                                                })}
                                                                                                            </TableCell>
                                                                                                        ))}
                                                                                                    </TableRow>
                                                                                                ))
                                                                                            ) : (
                                                                                                <TableRow key={`nested-past-direct-${nestedIndex}`} sx={rowStyle}>
                                                                                                    <TableCell sx={{ ...rowStyle, pl: 2 }}>
                                                                                                        <Typography sx={{ fontSize: '11px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                                                            {nestedChildren.fieldName}
                                                                                                        </Typography>
                                                                                                    </TableCell>
                                                                                                    <TableCell sx={{ ...rowStyle, textAlign: 'center', px: 0.5 }}>
                                                                                                        {renderFieldControl({
                                                                                                            val: nestedChildren,
                                                                                                            fieldValue: findFieldValue(test.values, nestedChildren.fieldKey),
                                                                                                            edit: edit,
                                                                                                            onValueChange: (newVal) => setPastNestedChildValueByKey(test.id, nestedChildren.fieldKey, newVal, pastTestIndex)
                                                                                                        })}
                                                                                                    </TableCell>
                                                                                                    {test.repeats.map((repeatTest, rIdx) => (
                                                                                                        <TableCell key={rIdx} sx={{ ...rowStyle, textAlign: 'center', px: 0.5 }}>
                                                                                                            {renderFieldControl({
                                                                                                                val: nestedChildren,
                                                                                                                fieldValue: findFieldValue(repeatTest.values, nestedChildren.fieldKey),
                                                                                                                edit: false,
                                                                                                                onValueChange: null
                                                                                                            })}
                                                                                                        </TableCell>
                                                                                                    ))}
                                                                                                </TableRow>
                                                                                            )}
                                                                                        </React.Fragment>
                                                                                    );
                                                                                })}
                                                                            </React.Fragment>
                                                                        );
                                                                    })}
                                                                </TableBody>
                                                            </Table>
                                                            {
                                                                edit && <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 'auto', mb: 1, mr: 1, pt: 1 }}>
                                                                    {test.submitted ? <Typography
                                                                        sx={{ height: '19px',px:2, fontSize: '9px', backgroundColor: 'rgba(134, 144, 148, 0.6)', color: '#FFF', borderRadius: '5px', alignContent: 'center' }}>
                                                                        SUBMITTED
                                                                    </Typography> : <Button
                                                                        variant="contained"
                                                                        onClick={() => {
                                                                            setPastTests((prevState) => {
                                                                                return prevState.map(preTest => ({
                                                                                    ...preTest,
                                                                                    tests: preTest.tests.map(testItem => {
                                                                                        if (testItem.id === test.id) {
                                                                                            return {
                                                                                                ...testItem,
                                                                                                submitted: true
                                                                                            };
                                                                                        }
                                                                                        return testItem;
                                                                                    })
                                                                                }));
                                                                            });
                                                                            store.dispatch(patientActions.submitPatientTestsRequestAction(test.id, {
                                                                                values: test.values,
                                                                                "labName": test.labName
                                                                            }))
                                                                        }}

                                                                        sx={{ height: '19px', width: '58px', fontSize: '9px', backgroundColor: '#F27704' }}
                                                                    >
                                                                        Submit
                                                                    </Button>
                                                                    }
                                                                </Box>
                                                            }
                                                            {
                                                                !edit && <Box justifySelf={'flex-end'} sx={{ marginBottom: 1, marginRight: 1, height: '3px' }}>
                                                                </Box>
                                                            }
                                                        </TableContainer>
                                                    ))
                                                )
                                                    :
                                                    <Typography>No tests this week</Typography>
                                                }
                                            </Box>
                                        </TimelineContent>
                                    </TimelineItem>
                                )
                            })}
                        </Timeline>
                        <Dialog
                            open={openModal}
                            onClose={() => setOpenModal(false)}
                            maxWidth="md"
                            fullWidth
                            fullScreen={isMobile}
                        >
                            <DialogContent sx={{ position: "relative", p: 2 }}>

                                {/* Close Button */}
                                <IconButton
                                    onClick={() => setOpenModal(false)}
                                    sx={{ position: "absolute", right: 10, top: isMobile ? 1 : 10, backgroundColor: isMobile ? '#FFF' : 'transparent' }}
                                >
                                    <CloseIcon />
                                </IconButton>

                                {/* Preview */}
                                {previewType === "image" ? (
                                    <img
                                        src={previewUrl}
                                        alt="preview"
                                        style={{ width: "100%", borderRadius: 8 }}
                                    />
                                ) : (
                                    <iframe
                                        src={previewUrl}
                                        title="pdf-preview"
                                        width="100%"
                                        height={isMobile ? '100%' : '600px'}
                                        style={{ border: "none" }}
                                    />
                                )}
                            </DialogContent>
                        </Dialog>
                    </Box>
                  
                </>
                    :
                    <CircularProgress />
                }
            </Box>
        </>

    );
};

export default TestBlocks;